import { ArrowUpRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useMagnetic } from "@/components/effects";

const NAV = [
  { label: "Problem", to: "/problem" },
  { label: "Approach", to: "/approach" },
  { label: "About", to: "/about" },
  { label: "Platforms", to: "/platforms" },
  { label: "Process", to: "/process" },
  { label: "Pricing", to: "/pricing" },
  { label: "FAQ", to: "/faq" },
];

export default function Header() {
  const magRef = useMagnetic(0.25);
  const { pathname } = useLocation();
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-2 group"
        >
          <span className="w-2.5 h-2.5 bg-yellow-400 inline-block" />
          <span className="font-heading text-sm tracking-tight font-medium">
            Invisible System Design
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => {
            const active = pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className={`text-xs uppercase tracking-[0.18em] transition-colors ${
                  active ? "text-yellow-400" : "text-zinc-400 hover:text-white"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <a
          ref={magRef}
          href="sms:+13104295413?&body=Hey%20Robbe!%20I'm%20so%20intrigued%2C%20what%20do%20you%20need%20for%20me%20to%20start%3F"
          data-testid="header-cta-button"
          className="group inline-flex items-center gap-2 bg-yellow-400 text-black px-4 py-2 text-xs uppercase tracking-[0.18em] font-medium hover:bg-yellow-500"
        >
          Start Project
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
        </a>
      </div>
    </header>
  );
}
